// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".require{min-width:2.4rem;width:2.4rem}.require .require-label{color:#d94a7d;font-size:.8rem;border:1px solid #d94a7d;padding:0 4px 0 4px;margin:3px 0 4px 0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
